<template>
  <div class="container mt-4">
    <div class="row justify-content-center">
      <div class="col-11">
        <NodeContentViewer v-if="focusDiagItem" :body="focusDiagItem.body" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NodeContentViewer from './NodeContentViewer';

export default {
  name: 'article-view',
  components: {
    NodeContentViewer,
  },
  props: {
    isPreview: {
      type: Boolean,
      default: false,
    },
    previewArticle: {
      type: Object,
      default: () => {},
    },
  },
  computed: mapGetters('webKnowledgeModule', ['focusDiagItem']),
};
</script>
